module.exports = __webpack_public_path__ + "assets/adadfe9d52c16b9c0b7a0842ab63c49a.svg";